
import React, { useEffect, useRef } from 'react';
import { Box, Button } from '@mui/material';

const HtmlEditor = ({ value, onChange, placeholder }) => {
  const editorRef = useRef(null);

  const handleFormatting = (command) => {
    document.execCommand(command, false, null);
  };

  const handleContentChange = () => {
    if (editorRef.current) {
      const updatedContent = editorRef.current.innerHTML;
      onChange && onChange(updatedContent); 
    }
  };

  useEffect(() => {
    if (editorRef.current && editorRef.current.innerHTML !== value) {
      editorRef.current.innerHTML = value || ''; 
    }
  }, [value]);

  return (
    <Box>
      <Box mb={1}>
        <Button onClick={() => handleFormatting('bold')}>Bold</Button>
        <Button onClick={() => handleFormatting('italic')}>Italic</Button>
        <Button onClick={() => handleFormatting('underline')}>Underline</Button>
        <Button onClick={() => handleFormatting('insertUnorderedList')}>Bullet Points</Button>
        <Button onClick={() => handleFormatting('insertOrderedList')}>Numbered Points</Button>
      </Box>
      
      <Box
        ref={editorRef}
        contentEditable
        suppressContentEditableWarning
        onInput={handleContentChange}
        placeholder={placeholder}
        sx={{
          border: '1px solid #ccc',
          borderRadius: '4px',
          padding: '8px',
          minHeight: '100px',
          maxHeight:'200px',
          direction: 'ltr',
          textAlign: 'left',
          overflowY:'scroll'
        }}
      />
    </Box>
  );
};

export default HtmlEditor;